/* sâmago · Mega menú "Productos" (desktop).
   Hover abre; sale con delay ~200ms para evitar flicker entre trigger, sidebar y panel.
   Las categorías madre cambian el panel activo sin navegar; "Ver toda la categoría" navega.
   Escape cierra + foco al trigger. Click fuera cierra. aria-expanded/hidden sincronizados. */
(function () {
  var CLOSE_DELAY = 200;
  var HEADER_GAP = 40;
  var WIDE_HEADER_MIN_WIDTH = 720;
  var EXTRA_WIDE_HEADER_MIN_WIDTH = 800;
  var WIDE_HEADER_CLASS = 'samago-mm__category-panel--wide-header';
  var EXTRA_WIDE_HEADER_CLASS = 'samago-mm__category-panel--extra-wide-header';
  var STACKED_HEADER_CLASS = 'samago-mm__category-panel--stacked-header';

  function getPanel(mm) {
    return mm.querySelector('.samago-mm__panel');
  }

  function getPrimaries(mm) {
    return Array.prototype.slice.call(mm.querySelectorAll('[data-samago-mm-primary]'));
  }

  function getPanels(mm) {
    return Array.prototype.slice.call(mm.querySelectorAll('[data-samago-mm-panel]'));
  }

  function getActivePanel(mm) {
    return mm.querySelector('[data-samago-mm-panel].is-active');
  }

  function getMainCategories(mm) {
    return mm.querySelector('.samago-mm__main-categories');
  }

  function getHeaderParts(categoryPanel) {
    if (!categoryPanel) return null;
    return {
      header: categoryPanel.querySelector('.samago-mm__content-head'),
      title: categoryPanel.querySelector('.samago-mm__category-title'),
      viewAll: categoryPanel.querySelector('.samago-mm__view-all')
    };
  }

  function resetHeaderFit(categoryPanel) {
    if (!categoryPanel) return;
    categoryPanel.classList.remove(WIDE_HEADER_CLASS, EXTRA_WIDE_HEADER_CLASS, STACKED_HEADER_CLASS);
  }

  function resetAllHeaderFits(mm) {
    getPanels(mm).forEach(resetHeaderFit);
  }

  function canFitHeaderWidth(mm, targetPanelWidth) {
    var panel = getPanel(mm);
    var mainCategories = getMainCategories(mm);
    var panelWidth = panel ? panel.getBoundingClientRect().width : window.innerWidth;
    var mainWidth = mainCategories ? mainCategories.getBoundingClientRect().width : 0;
    return targetPanelWidth + mainWidth <= panelWidth;
  }

  function headerNeedsMoreRoom(header, title, viewAll) {
    if (!header || !title || !viewAll) return false;

    var titleRect = title.getBoundingClientRect();
    var viewAllRect = viewAll.getBoundingClientRect();
    if (!titleRect.width || !viewAllRect.width) return false;

    var titleFragments = Array.prototype.slice.call(title.getClientRects());
    var lineHeight = parseFloat(window.getComputedStyle(title).lineHeight) || titleRect.height;
    var lineCount = Math.max(1, titleFragments.length, Math.round(titleRect.height / lineHeight));
    var titleOverflows = title.scrollWidth > title.clientWidth + 1;
    var viewAllOverflows = viewAll.scrollWidth > viewAll.clientWidth + 1;
    var overlapsVertically = viewAllRect.bottom > titleRect.top && viewAllRect.top < titleRect.bottom;
    var inlineGap = viewAllRect.left - titleRect.right;

    if (titleOverflows || viewAllOverflows) return true;
    if (lineCount > 1 && overlapsVertically) return true;
    return overlapsVertically && inlineGap < HEADER_GAP;
  }

  function fitActiveHeader(mm) {
    var categoryPanel = getActivePanel(mm);
    resetAllHeaderFits(mm);
    if (!categoryPanel || categoryPanel.classList.contains('samago-mm__category-panel--empty')) return;

    if (window.matchMedia && window.matchMedia('(max-width: 1180px)').matches) {
      categoryPanel.classList.add(STACKED_HEADER_CLASS);
      return;
    }

    var parts = getHeaderParts(categoryPanel);
    if (!parts || !parts.header || !parts.title || !parts.viewAll) return;

    if (!headerNeedsMoreRoom(parts.header, parts.title, parts.viewAll)) return;

    if (canFitHeaderWidth(mm, WIDE_HEADER_MIN_WIDTH)) {
      categoryPanel.classList.add(WIDE_HEADER_CLASS);
      categoryPanel.getBoundingClientRect();
      if (!headerNeedsMoreRoom(parts.header, parts.title, parts.viewAll)) return;
    }

    if (canFitHeaderWidth(mm, EXTRA_WIDE_HEADER_MIN_WIDTH)) {
      categoryPanel.classList.remove(WIDE_HEADER_CLASS);
      categoryPanel.classList.add(EXTRA_WIDE_HEADER_CLASS);
      categoryPanel.getBoundingClientRect();
      if (!headerNeedsMoreRoom(parts.header, parts.title, parts.viewAll)) return;
    }

    categoryPanel.classList.remove(WIDE_HEADER_CLASS, EXTRA_WIDE_HEADER_CLASS);
    categoryPanel.classList.add(STACKED_HEADER_CLASS);
  }

  function isEmptyPrimary(primary) {
    if (!primary) return false;
    return Number(primary.getAttribute('data-samago-mm-subcategory-count') || 0) === 0;
  }

  // El contenido visual nunca debe salir del viewport: max-height = viewport - top real visible - 12px.
  function fitPanel(mm) {
    var panel = getPanel(mm);
    if (!panel) return;
    var activePanel = getActivePanel(mm);
    var mainCategories = getMainCategories(mm);
    var panelRectTop = panel.getBoundingClientRect().top;
    var panelTop = panel.offsetParent
      ? panel.offsetParent.getBoundingClientRect().top + panel.offsetTop
      : panelRectTop;
    var availableTop = panelTop;
    if (mainCategories) {
      var mainCategoriesTop = panelTop + (mainCategories.getBoundingClientRect().top - panelRectTop);
      availableTop = Math.max(availableTop, mainCategoriesTop);
    }
    if (activePanel) {
      var activePanelTop = panelTop + (activePanel.getBoundingClientRect().top - panelRectTop);
      availableTop = Math.max(availableTop, activePanelTop);
    }
    var maxPanelHeight = Math.max(0, window.innerHeight - availableTop - 12);
    var contentHeight = activePanel ? activePanel.scrollHeight : 0;
    var categoriesHeight = mainCategories ? mainCategories.scrollHeight : 0;
    var panelHeight = Math.min(Math.max(contentHeight, categoriesHeight), maxPanelHeight);
    panel.style.setProperty('--samago-mm-panel-max-height', panelHeight + 'px');
  }

  function setPanelHidden(mm, hidden) {
    var panel = getPanel(mm);
    if (panel) panel.setAttribute('aria-hidden', hidden ? 'true' : 'false');
  }

  function resetActiveCategory(mm) {
    mm.classList.add('is-resetting-panel');

    getPrimaries(mm).forEach(function (primary, index) {
      primary.classList.remove('is-active');
      primary.setAttribute('aria-selected', 'false');
      primary.setAttribute('tabindex', index === 0 ? '0' : '-1');
    });

    getPanels(mm).forEach(function (categoryPanel) {
      categoryPanel.classList.remove('is-active');
      categoryPanel.setAttribute('aria-hidden', 'true');
    });

    resetAllHeaderFits(mm);
    mm.classList.remove('has-active-panel');
    fitPanel(mm);

    window.requestAnimationFrame(function () {
      mm.classList.remove('is-resetting-panel');
    });
  }

  function setActiveCategory(mm, key, focusPrimary) {
    if (!key) return;

    mm.classList.remove('is-resetting-panel');
    var activePrimary = null;

    getPrimaries(mm).forEach(function (primary) {
      var isActive = primary.getAttribute('data-samago-mm-primary') === key;
      primary.classList.toggle('is-active', isActive);
      primary.setAttribute('aria-selected', isActive ? 'true' : 'false');
      primary.setAttribute('tabindex', isActive ? '0' : '-1');
      if (isActive) activePrimary = primary;
      if (isActive && focusPrimary) primary.focus();
    });

    if (activePrimary && isEmptyPrimary(activePrimary)) {
      getPanels(mm).forEach(function (categoryPanel) {
        categoryPanel.classList.remove('is-active');
        categoryPanel.setAttribute('aria-hidden', 'true');
      });
      resetAllHeaderFits(mm);
      mm.classList.remove('has-active-panel');
      fitPanel(mm);
      return;
    }

    mm.classList.add('has-active-panel');

    getPanels(mm).forEach(function (categoryPanel) {
      var isActive = categoryPanel.getAttribute('data-samago-mm-panel') === key;
      categoryPanel.classList.toggle('is-active', isActive);
      categoryPanel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
    });

    fitActiveHeader(mm);
    fitPanel(mm);
  }

  function moveActive(mm, direction) {
    var primaries = getPrimaries(mm);
    if (!primaries.length) return;
    var currentIndex = primaries.findIndex(function (primary) {
      return primary.classList.contains('is-active');
    });
    var nextIndex = currentIndex < 0
      ? (direction > 0 ? 0 : primaries.length - 1)
      : (currentIndex + direction + primaries.length) % primaries.length;
    setActiveCategory(mm, primaries[nextIndex].getAttribute('data-samago-mm-primary'), true);
  }

  function closeMenu(mm) {
    var trigger = mm.querySelector('.samago-mm__trigger');
    resetActiveCategory(mm);
    mm.classList.remove('is-open');
    setPanelHidden(mm, true);
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
  }

  function focusTriggerAfterClose(mm) {
    var trigger = mm.querySelector('.samago-mm__trigger');
    if (!trigger) return;
    mm.dataset.samagoMmSuppressFocusOpen = '1';
    trigger.focus();
    window.setTimeout(function () {
      delete mm.dataset.samagoMmSuppressFocusOpen;
    }, 80);
  }

  function closeAllOpenMenus(focusTrigger) {
    document.querySelectorAll('[data-samago-mm].is-open').forEach(function (mm) {
      closeMenu(mm);
      if (focusTrigger) focusTriggerAfterClose(mm);
    });
  }

  function openMenu(mm) {
    var trigger = mm.querySelector('.samago-mm__trigger');
    mm.classList.add('is-open');
    setPanelHidden(mm, false);
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    fitPanel(mm);
    window.requestAnimationFrame(function () {
      fitPanel(mm);
    });
  }

  function init() {
    document.querySelectorAll('[data-samago-mm]').forEach(function (mm) {
      if (mm.dataset.samagoMmReady) return;
      mm.dataset.samagoMmReady = '1';

      var trigger = mm.querySelector('.samago-mm__trigger');
      var timer = null;
      resetActiveCategory(mm);

      function open() {
        clearTimeout(timer);
        openMenu(mm);
      }

      function closeSoon() {
        clearTimeout(timer);
        timer = setTimeout(function () {
          closeMenu(mm);
        }, CLOSE_DELAY);
      }

      mm.addEventListener('mouseenter', open);
      mm.addEventListener('mouseleave', closeSoon);
      mm.addEventListener('focusin', function () {
        if (mm.dataset.samagoMmSuppressFocusOpen === '1') return;
        open();
      });
      mm.addEventListener('focusout', function (e) {
        if (!mm.contains(e.relatedTarget)) closeSoon();
      });

      getPrimaries(mm).forEach(function (primary) {
        primary.addEventListener('mouseenter', function () {
          setActiveCategory(mm, primary.getAttribute('data-samago-mm-primary'), false);
        });
        primary.addEventListener('focus', function () {
          setActiveCategory(mm, primary.getAttribute('data-samago-mm-primary'), false);
        });
        primary.addEventListener('click', function (e) {
          if (isEmptyPrimary(primary)) return;
          e.preventDefault();
          setActiveCategory(mm, primary.getAttribute('data-samago-mm-primary'), false);
        });
        primary.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowDown') {
            e.preventDefault();
            moveActive(mm, 1);
          } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            moveActive(mm, -1);
          } else if (e.key === 'Home') {
            e.preventDefault();
            var first = getPrimaries(mm)[0];
            if (first) setActiveCategory(mm, first.getAttribute('data-samago-mm-primary'), true);
          } else if (e.key === 'End') {
            e.preventDefault();
            var primaries = getPrimaries(mm);
            var last = primaries[primaries.length - 1];
            if (last) setActiveCategory(mm, last.getAttribute('data-samago-mm-primary'), true);
          } else if (e.key === 'Escape') {
            e.preventDefault();
            closeMenu(mm);
            focusTriggerAfterClose(mm);
          }
        });
      });

      if (trigger) {
        trigger.addEventListener('click', function (e) {
          if (!mm.classList.contains('is-open')) {
            e.preventDefault();
            open();
          }
        });
      }

      mm.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && mm.classList.contains('is-open')) {
          e.preventDefault();
          closeMenu(mm);
          focusTriggerAfterClose(mm);
        }
      });
    });
  }

  document.addEventListener('click', function (e) {
    document.querySelectorAll('[data-samago-mm].is-open').forEach(function (mm) {
      if (!mm.contains(e.target)) closeMenu(mm);
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeAllOpenMenus(true);
    }
  });

  window.addEventListener('resize', function () {
    document.querySelectorAll('[data-samago-mm].is-open').forEach(function (mm) {
      fitActiveHeader(mm);
      fitPanel(mm);
    });
  });

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
